/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

/**
 * Список необходимых полей для запросов к api/v3/search в каталоге.
 * @type {Array}
 */
app.API_SEARCH_FIELDS = [
  'id',
  'sid',
  'uid',
  'name',
  'slug',
  'balance',
  'is_disabled',
  'price',
  'price_max',
  'currency',
  'in_box',
  'in_set',
  'unit_id',
  'video_file_url',
  'is_price_fixed',
  'is_adult',
  'is_protected',
  'max_qty',
  'min_qty',
  'modifier_id',
  'modifier_value',
  'qty_multiplier',
  'is_loco',
  'has_discount',
  'is_gift',
  'has_action',
  'mean_rating',
  'comments_count',
  'offer',
  'type',
  'currencySign',
  'isEnough',
  'isAddToCartMultiple',
  'minQty',
  'qtyRule',
  'qty_rules',
  'qty_rules_data',
  'custom_qty_rules_data',
  'pluralNameFormat',
  'inBoxPluralNameFormat',
  'balancePluralNameFormat',
  'weight',
  'special_offer_id',
  'wholesale_price',
  'has_special_offer',
  'is_remote_store',
  'is_small_wholesale_available',
  'color',
  'short_name',
  'img',
  'photos',
  'country',
  'discountPercent',
  'itemUrl',
  'modifier',
  'size',
  'stuff',
  'trademark',
  'series',
  'ecommerce_variant',
  'real_min_qty',
  'category_id',
  'transit_in_settlement',
  'small_modifiers',
  'photo_sizes',
  'cart_item',
  'is_weighted_goods',
  'wish_item',
  'attrs',
  'nestedUnit',
  // доп. поля для cart_item
  'total_price',
  'qty',
  'retail_fee_markup',
  'restriction_qty',
  'root_category_id',
  'qty_total_price',
  'item_sid',
  'item_id',
  'is_balanced',
  'has_accessory_items',
  'cart_id',
  // доп.поля для wish_item
  'wish_id',
  // внутренние поля сущностей
  'attrs.attr_id',
  'attrs.boolean_value',
  'attrs.value',
  'country.name',
  'trademark.name',
  'trademark.slug',
];

}.call(window));